import React, { useContext } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { DatepickerContext } from '../context';
function DatepickerTrigger(props) {
  const {
    triggerLabel,
    triggerClassName,
    arrowClassName,
    onTriggerSelect,
    triggerStyles
  } = props;
  const {
    isOpen,
    setIsOpen,
    withInput,
    datepickerTriggerRef
  } = useContext(DatepickerContext);
  const triggerClass = classNames({
    'sib-datepicker-trigger': true,
    'sib-datepicker-trigger-focused': isOpen && !withInput,
    [triggerClassName]: !!triggerClassName
  });
  const arrowClass = classNames({
    'sib-dropdown-arrow': true,
    [arrowClassName]: !!arrowClassName
  });
  const handleOnClick = e => {
    e.preventDefault();
    if (isOpen) {
      setIsOpen(false);
    } else {
      setIsOpen(true);
    }
    onTriggerSelect(e);
  };
  const handleKeyDown = event => {
    if (event.key === 'Enter') {
      handleOnClick(event);
    }
    if (event.keyCode === 40) {
      handleOnClick(event);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: triggerClass,
    style: triggerStyles,
    ref: datepickerTriggerRef,
    role: "button",
    tabIndex: "0",
    onClick: handleOnClick,
    onKeyDown: handleKeyDown,
    "aria-haspopup": "listbox"
  }, /*#__PURE__*/React.createElement("div", {
    className: "sib-datepicker-trigger__placeholder"
  }, /*#__PURE__*/React.createElement("div", {
    className: "sib-datepicker-trigger--selected-value",
    dangerouslySetInnerHTML: {
      __html: triggerLabel || ''
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: `sib-dropdown-arrow-wrapper`
  }, /*#__PURE__*/React.createElement("span", {
    className: arrowClass
  })));
}
DatepickerTrigger.propTypes = {
  triggerLabel: PropTypes.string.isRequired,
  triggerClassName: PropTypes.string,
  arrowClassName: PropTypes.string,
  onTriggerSelect: PropTypes.func,
  triggerStyles: PropTypes.object
};
DatepickerTrigger.defaultProps = {
  triggerLabel: '',
  triggerClassName: '',
  arrowClassName: '',
  triggerStyles: {},
  onTriggerSelect: () => {}
};
export default DatepickerTrigger;